import React from 'react';

import { Avatar, Title } from '@mantine/core';

interface IHeaderProps {
  logo?: string | null | undefined;
  gymTitle?: string | null | undefined;
}

const Header = ({ logo, gymTitle }: IHeaderProps): JSX.Element => {
  return (
    <div className='header'>
      {logo ? (
        <div className='logo'>
          <Avatar
            alt='Gym Logo'
            style={{ width: '70px', height: 'auto', objectFit: 'contain' }}
            src={logo}
          />
        </div>
      ) : null}

      <div className='titleWrapper'>
        <Title order={1} truncate>
          {gymTitle}
        </Title>
      </div>
    </div>
  );
};

export default Header;
